import config from '@/config'
import getPages from '@/pages.js'
import getMobilePages from '@/mobliepages.js'
import Vue from 'vue'
import store from '@/store/index'
import Router from 'vue-router'
import { isUndefined, isNullOrUndefined } from 'util'
import helper from '@/vueHelper'

Vue.use(Router)



export default function getRouter(){
  const router = new Router({
    base: config.serverBase,
    // mode: 'history',
    linkActiveClass: "active",
    routes: [{
      path: '/login',
      name: 'login',
      meta: {
        // requireAuth: true
      },
  
      component: () => import('@/views/Login.vue')
    },
    {
      name: 'logout',
      path: '/logout',
      component: () => import('@/views/Logout.vue'),
      meta: {
  
      },
    },
    {
      path: '/Auth',
      name: 'auth',
      meta: {
        // requireAuth: true
      },
  
      component: () => import('@/views/Auth.vue')
    },
    {
      name: 'grapheditor',
      path: '/grapheditor',
      component: () => import('@/views/grapheditor.vue'),
      meta: {
  
      },
    },
   
    {
      path: '*',
      name: '404',
      component: () => import('@/views/Error404.vue'),
    },
  
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'Inbox'
      },
      meta: {
  
        title: "Inbox",
      },
      component: () => import( /* webpackChunkName: "home" */ '@/views/Home.vue'),
      //props: (route) => ({
      //title: 'home'
      //}),
      children: [
        ...getPages(),
  
      ]
    },
    {
      path: '/Mobile',
      name: 'Mobilehome',
      redirect: {
        name: 'MobileDashboard'
      },
      meta: {
  
        title: "MobileDashboard",
      },
      component: () => import( /* webpackChunkName: "home" */ '@/views/MobileHome.vue'),
      //props: (route) => ({
      //title: 'home'
      //}),
      children: [
        ...getMobilePages(),
  
      ]
    },
    ]
    // linkExactActiveClass: "exact-active",
  })
  
  router.beforeEach(async (to, from, next) => {
    // 如果 router 轉跳的頁面需要驗證 requiresAuth: true
    // console.log('to=', to.fullPath, '| from=', from.fullPath);
    //reset
  
    let needClear = !isNullOrUndefined(to.params.clear) ? to.params.clear : true
  
    if (needClear) {
      store.dispatch("grid/actionSetViewMode", true);
      store.dispatch("grid/actionSetToggleGridResize", false);
      store.dispatch("grid/actionSetToggleGridResize", false);
      store.dispatch("grid/actionResetAllGrid");
      store.dispatch("filters/actionReSetFilterMode");
      store.dispatch("filters/actionResetData");
      store.dispatch("actioResetlinkHandling");
      store.dispatch("message/actionResetMessage");
      store.dispatch("actionSetForceBlock", true);
    }
  
  
    //useless
    // if (to.name === 'login') {
    //   if (window.localStorage.getItem("ccrs_user") !== null) {
    //     next({
    //       path: '/Dashboard'
    //     });
    //   } else {
    //     next();
    //   }
    //   return;
    // }
  
    //only this 3 pages not check login
    let excludeAuth = ["/login", "/logout", "404", "/Mobile/MobileDashboard", "/auth","slimtest","/public"]
  
    let requiresAuth = helper.includes(excludeAuth, to.path) || helper.includes(excludeAuth, to.name) ? false : true
  
    if (requiresAuth) {
      //
      if (window.localStorage.getItem("ccrs_user") !== null) {
        var sysUserString = window.localStorage.getItem("ccrs_user") || "null";
        if (sysUserString == "[object Object]") {
          sysUserString = "null";
        }
  
        var sysUser = JSON.parse(sysUserString);
  
        if (sysUser && store.state.user !== sysUser) {
          store.dispatch("actionSetUser", sysUser);
          store.dispatch("actionSetToken", window.localStorage.getItem("ccrs_token"));
        }
  
        let hasAccess = helper.hasAccess(to.meta.access_code);
        if (hasAccess) {
          next();
        } else {
          $(".bs-tooltip-right").remove();
          next({
            path: '/*',
            query: {
              msg: `You don't have permission to access on this page (CODE:${to.meta.access_code})`,
            }
          });
        }
        // next();
      } else {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      }
      // console.log('token?', store.state.token);
      // if (window.localStorage.getItem("ccrs_user") === '' || window.localStorage.getItem("ccrs_user") === null) {
      //   // 轉跳到 login page
      //   next({
      //     path: '/login'
      //   });
      // } else {
      //   next(); // 往下繼續執行
      // }
    } else {
      next(); // 往下繼續執行
    }
  });
  
  return router;
}

